import { chakra } from "@chakra-ui/react";
import { motion } from "framer-motion";

const MotionBox = motion(chakra.div);

export default MotionBox;
